module.exports = __webpack_public_path__ + "img/fractel.c82128f6.png";